export const COKE_AUTH_USER_TOKEN = "COKE_AUTH_USER_TOKEN";
export const COKE_AUTH_USER_DATA = "COKE_AUTH_USER_DATA";
